import React, { useState } from "react";
import { Container, Row, Col, Form, Button, InputGroup } from "react-bootstrap";
import { FiMail, FiUser, FiEye, FiEyeOff } from "react-icons/fi";
import login from "../../assets/css/signup.css"
import { Link } from "react-router-dom";

const Signup = () => {
  const [showPass, setShowPass] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  return (
    <div className="main-wrapper">
      <Container fluid>
        <Row className="vh-100">

          {/* LEFT SIDE */}
          <Col lg={5} className="login-left d-none d-lg-flex">
            <div className="bg-overlay-img">
              <img src="/assets/img/bg/bg-01.png" className="bg-1" />
              <img src="/assets/img/bg/bg-02.png" className="bg-2" />
              <img src="/assets/img/bg/bg-03.png" className="bg-3" />
            </div>

            <div className="overlay-card">
              <h1>
                Empowering people <br />
                through seamless HR <br />
                management.
              </h1>

              <img
                src="/assets/img/bg/authentication-bg-01.png"
                className="team-img"
                alt=""
              />

              <p>
                Efficiently manage your workforce, streamline <br />
                operations effortlessly.
              </p>
            </div>
          </Col>

          {/* RIGHT SIDE */}
          <Col lg={7} className="login-right">

            <div className="login-form-wrapper">

              {/* LOGO */}
              <div className="text-center mb-4">
                <img src="/assets/img/logo-1.svg" height="40" />
              </div>

              <h2 className="text-center">Sign Up</h2>
              <p className="text-center text-muted mb-4">
                Please enter your details to sign up
              </p>

              {/* NAME */}
              <Form.Group className="mb-3">
                <Form.Label>Name</Form.Label>
                <InputGroup>
                  <Form.Control type="text" />
                  <InputGroup.Text>
                    <FiUser />
                  </InputGroup.Text>
                </InputGroup>
              </Form.Group>

              {/* EMAIL */}
              <Form.Group className="mb-3">
                <Form.Label>Email Address</Form.Label>
                <InputGroup>
                  <Form.Control type="email" />
                  <InputGroup.Text>
                    <FiMail />
                  </InputGroup.Text>
                </InputGroup>
              </Form.Group>

              {/* PASSWORD */}
              <Form.Group className="mb-3">
                <Form.Label>Password</Form.Label>
                <div className="password-box">
                  <Form.Control type={showPass ? "text" : "password"} />
                  <span onClick={() => setShowPass(!showPass)}>
                    {showPass ? <FiEyeOff /> : <FiEye />}
                  </span>
                </div>
              </Form.Group>

              {/* CONFIRM PASSWORD */}
              <Form.Group className="mb-3">
                <Form.Label>Confirm Password</Form.Label>
                <div className="password-box">
                  <Form.Control type={showConfirm ? "text" : "password"} />
                  <span onClick={() => setShowConfirm(!showConfirm)}>
                    {showConfirm ? <FiEyeOff /> : <FiEye />}
                  </span>
                </div>
              </Form.Group>

              {/* TERMS */}
              <Form.Check
                label={
                  <>
                    Agree to <span className="text-danger">Terms & Privacy</span>
                  </>
                }
                className="mb-3"
              />

              {/* BUTTON */}
              <Button className="w-100 login-btn">Sign Up</Button>

              {/* LOGIN LINK */}
              <div className="text-center mt-3">
                Already have an account?{" "}
                <Link  style={{color:"#F26522"}} to="/login" className="text-decoartion-none" >
   Sign In
                </Link>
              
              </div>

              {/* OR */}
              <div className="divider">Or</div>

              {/* SOCIAL */}
              <div className="d-flex gap-2">
                <Button className="social-btn fb w-100">
                  <img src="/assets/img/icons/facebook-logo.svg" />
                </Button>

                <Button className="social-btn google w-100">
                  <img src="/assets/img/icons/google-logo.svg" />
                </Button>

                <Button className="social-btn apple w-100">
                  <img src="/assets/img/icons/apple-logo.svg" />
                </Button>
              </div>

              {/* FOOTER */}
              <p className="text-center mt-4 text-muted">
                Copyright © 2026 - Smarthr
              </p>

            </div>
          </Col>

        </Row>
      </Container>
    </div>
  );
};

export default Signup;